/** @jsx h */
import Checkbox from './Checkbox';

const FilterFieldset = ({
  facet,
  triggerAjaxSubmit,
  pluginNamespace,
  searchType,
}) => (
  <li class="filter__item">
    <div class="filter__tag">
      <fieldset class="form__field">
        {searchType === 'calendar' && (
          <legend class="form__label">
            <span>{facet.label}</span>
          </legend>
        )}

        {facet.options.length && (
          <div class="form__group--tag">
            {facet.options.map(option => (
              <Checkbox
                option={option}
                filterName={facet.name}
                handleChange={triggerAjaxSubmit}
                pluginNamespace={pluginNamespace}
                key={option.value}
              />
            ))}
          </div>
        )}
      </fieldset>
    </div>
  </li>
);

export default FilterFieldset;
